webpackJsonp([213534597649335],{

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(301);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ButtonSquare = __webpack_require__(11);
	
	var _logo_comdeslezards = __webpack_require__(559);
	
	var _logo_comdeslezards2 = _interopRequireDefault(_logo_comdeslezards);
	
	var _picture_showcase = __webpack_require__(562);
	
	var _picture_showcase2 = _interopRequireDefault(_picture_showcase);
	
	var _picture_ecommerce = __webpack_require__(560);
	
	var _picture_ecommerce2 = _interopRequireDefault(_picture_ecommerce);
	
	var _picture_onmeasureapp = __webpack_require__(561);
	
	var _picture_onmeasureapp2 = _interopRequireDefault(_picture_onmeasureapp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexFirstView = function IndexFirstView() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'background_leaf' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      _react2.default.createElement('img', {
	        className: 'logo',
	        src: _logo_comdeslezards2.default,
	        alt: 'logo agence web com des l\xE9zards'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'service_container' },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', { src: _picture_showcase2.default, alt: 'illustration site vitrine portfolio' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'service_plus_button' },
	          _react2.default.createElement(_ButtonSquare.ButtonPlus, { link: '/sites-vitrine', theme: 'light' })
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Site vitrine'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Vous accordez une grande importance \xE0 votre image sur internet ? Vous souhaitez pr\xE9senter votre activit\xE9 sous le meilleur jour ? Avec un site internet con\xE7u exclusivement pour vous par un graphiste exp\xE9riment\xE9 ? Et performant car d\xE9velopp\xE9 avec les meilleures technologies du moment ? Alors n\'h\xE9sitez plus \xE0 nous contacter, notre agence web saura r\xE9pondre \xE0 vos besoins.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', {
	          src: _picture_ecommerce2.default,
	          alt: 'illustration site ecommerce marchand vente en ligne'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'service_plus_button' },
	          _react2.default.createElement(_ButtonSquare.ButtonPlus, { link: '/ecommerce' })
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          'eCommerce'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Vous vous lancez dans le eCommerce ? Vous souhaitez monter votre activit\xE9 de vente en ligne ? Le faire rapidement gr\xE2ce \xE0 des outils \xE9prouv\xE9s et une \xE9quipe r\xE9active ? Avoir un partenaire fiable avec de nombreuses r\xE9alisations r\xE9ussies \xE0 son actif ? L\'agence web Com des L\xE9zards saura vous accompagner alors contactez nous.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', {
	          src: _picture_onmeasureapp2.default,
	          alt: 'illustration application sur mesure progiciel'
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'service_plus_button' },
	          _react2.default.createElement(_ButtonSquare.ButtonPlus, { link: '/applications-sur-mesure' })
	        ),
	        _react2.default.createElement(
	          'h2',
	          {
	            style: {
	              marginTop: '5px',
	              marginBottom: '5px'
	            }
	          },
	          'Applications'
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'sur mesure'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Vous cherchez comment gagner du temps dans votre fonctionnement quotidien? Gagner en organisation, en fiabilit\xE9 en efficacit\xE9? Tout \xE7a de mani\xE8re simple car d\xE9velopp\xE9 exclusivement pour vous selon vos besoins? Vous avez cherch\xE9 mais n\u2019avez pas trouv\xE9 de solution g\xE9n\xE9rique qui corresponde r\xE9ellement \xE0 vos besoins? Ou alors elles \xE9taient trop complexes? Notre agence web r\xE9pond aussi \xE0 ce type de besoins avec des comp\xE9tences techniques \xE9lev\xE9s et des technologies innovantes.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'scroll_button' },
	      _react2.default.createElement(_ButtonSquare.ButtonScroll, { link: '#r\xE9f\xE9rences' })
	    )
	  );
	};
	
	exports.default = IndexFirstView;
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/picture_ecommerce.7b6ca04f.png";

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/picture_onmeasureapp.47da2b8e.png";

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/picture_showcase.5be5807f.png";

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IndexFirstView = __webpack_require__(178);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IndexFirstView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(303);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ButtonSquare = __webpack_require__(11);
	
	var _PostPreview = __webpack_require__(73);
	
	var _PostPreview2 = _interopRequireDefault(_PostPreview);
	
	var _TitleHeader = __webpack_require__(52);
	
	var _TitleHeader2 = _interopRequireDefault(_TitleHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexThirdView = function IndexThirdView(props) {
	  var articles = props.data.edges;
	
	  var postPreviewDivs = [];
	  if (articles) {
	    articles.forEach(function (element) {
	      var article = element.node;
	      postPreviewDivs.push(_react2.default.createElement(_PostPreview2.default, {
	        pictureSrc: article.pictures[0].sizes,
	        alt: article.pictures[0].alt,
	        title: article.title,
	        subtitle: article.subtitle,
	        link: '/' + article.slug,
	        theme: 'dark'
	      }));
	    });
	  }
	  var randomBackground = Math.floor(Math.random() * Math.floor(3)) + 1;
	  if (typeof window !== 'undefined') {
	    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	    if (viewportWidth <= 1400) {
	      randomBackground = 2;
	    }
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'third-view-body background_' + randomBackground, id: 'articles' },
	    _react2.default.createElement(_TitleHeader2.default, {
	      title: 'Nous partageons avec vous',
	      titleColor: '#dedee3',
	      subtitle: 'Derniers articles',
	      subtitleColor: '#4d12c7'
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'post-container' },
	      postPreviewDivs
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'footer' },
	      _react2.default.createElement(
	        _ButtonSquare.ButtonText,
	        { theme: 'dark', link: '/blog' },
	        'Voir tous les articles'
	      )
	    )
	  );
	};
	
	IndexThirdView.defaultProps = {
	  data: {}
	};
	
	IndexThirdView.propTypes = {
	  data: _propTypes2.default.shape({
	    edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      pictures: _propTypes2.default.array, title: _propTypes2.default.string, subtitle: _propTypes2.default.string, slug: _propTypes2.default.string
	    }))
	  })
	};
	
	exports.default = IndexThirdView;
	module.exports = exports['default'];

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _IndexThirdView = __webpack_require__(181);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IndexThirdView).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _ContactView = __webpack_require__(5);
	
	var _ContactView2 = _interopRequireDefault(_ContactView);
	
	var _FooterView = __webpack_require__(6);
	
	var _FooterView2 = _interopRequireDefault(_FooterView);
	
	var _IndexFirstView = __webpack_require__(179);
	
	var _IndexFirstView2 = _interopRequireDefault(_IndexFirstView);
	
	var _IndexSecondView = __webpack_require__(50);
	
	var _IndexSecondView2 = _interopRequireDefault(_IndexSecondView);
	
	var _IndexThirdView = __webpack_require__(182);
	
	var _IndexThirdView2 = _interopRequireDefault(_IndexThirdView);
	
	var _View = __webpack_require__(7);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  var _props$data = props.data,
	      previewProjects = _props$data.previewProjects,
	      previewArticles = _props$data.previewArticles;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{
	        name: 'description',
	        content: 'Depuis 2001, votre agence web avec un service de qualité pour tous vos projets web. Nous vous accompagnons dans la création de vos sites web vitrine, vos sites ecommerce et vos progiciels sur-mesures.'
	      }]
	    }),
	    _react2.default.createElement(
	      _View2.default,
	      { colorMode: '1' },
	      _react2.default.createElement(_IndexFirstView2.default, null),
	      _react2.default.createElement(_IndexSecondView2.default, { data: previewProjects }),
	      _react2.default.createElement(_IndexThirdView2.default, { data: previewArticles }),
	      _react2.default.createElement(_ContactView2.default, null),
	      _react2.default.createElement(_FooterView2.default, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-7efe62375ae2e688e39d.js